import { render, staticRenderFns } from "./our-partner.vue?vue&type=template&id=2b71562d&scoped=true&"
import script from "./our-partner.vue?vue&type=script&lang=js&"
export * from "./our-partner.vue?vue&type=script&lang=js&"
import style0 from "./our-partner.vue?vue&type=style&index=0&id=2b71562d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b71562d",
  null
  
)

export default component.exports